'use strict';

var GridToolbarConfigurationUserDefinedRefDataFlightDirective = function GridToolbarConfigurationUserDefinedRefDataFlightDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-user-defined-ref-data-flight.html'),
    controller: 'GridToolbarConfigurationUserDefinedRefDataFlightController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
      scope.$on('configuration-urd-flight:save', function () {
        scope.saveChanges();
      });
    }
  };
};
GridToolbarConfigurationUserDefinedRefDataFlightDirective.$inject = [];
module.exports = GridToolbarConfigurationUserDefinedRefDataFlightDirective;